import React, {Component} from 'react'
import LoginForm from './LoginForm'
import {login} from "../../lib/fetchService";

class Login extends Component {
    state = {
        loginError: null
    }
    loginSubmitHandler = async (username, password) => {

        try {
          const res = await login(username, password)
          this.props.onLogin(res.token);
        } catch (e) {
          this.setState({loginError: 'error'})
        }

    }
    render() {
        return (
            <LoginForm onSubmit={this.loginSubmitHandler} loginError={this.state.loginError} />
        )
    }
}



export default Login


// WEBPACK FOOTER //
// ./src/components/login/Login.js